import { render, staticRenderFns } from "./PublicDimBook.vue?vue&type=template&id=8a27f56e"
import script from "./PublicDimBook.vue?vue&type=script&lang=js"
export * from "./PublicDimBook.vue?vue&type=script&lang=js"
import style0 from "./PublicDimBook.vue?vue&type=style&index=0&id=8a27f56e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports